import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=a3c2c346&"
import script from "./forms.vue?vue&type=script&lang=js&"
export * from "./forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CFormLabel: require('@chakra-ui/vue').CFormLabel, CSelect: require('@chakra-ui/vue').CSelect, CFormControl: require('@chakra-ui/vue').CFormControl, CBox: require('@chakra-ui/vue').CBox, CImage: require('@chakra-ui/vue').CImage, CButton: require('@chakra-ui/vue').CButton, CStack: require('@chakra-ui/vue').CStack, CFlex: require('@chakra-ui/vue').CFlex, CInput: require('@chakra-ui/vue').CInput})
